<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch">
    <el-form-item label="申请时间">
      <!-- <el-date-picker
        v-model="dateRange"
        type="daterange"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        range-separator="-"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        :disabled-date="disabledDate"
        @blur="handleDateChange"
      /> -->
      <el-date-picker
        v-model="dateStartRange"
        type="date"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        placeholder="开始时间"
        :disabled-date="disabledDate"
        @change="handleDateStartChange"
      />
      <el-date-picker
        v-model="dateEndRange"
        type="date"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        placeholder="结束时间"
        :disabled-date="disabledDate"
        @change="handleDateEndChange"
      />
    </el-form-item>
    <el-form-item label="平台订单号">
      <el-input
        v-model="queryParam.platformnum"
        type="textarea"
        placeholder="多个使用回车分割"
        autosize
        @blur="autoFormat('platformnum', { unique: true })"
      />
    </el-form-item>
    <el-form-item label="垚旌订单号">
      <el-input
        v-model="queryParam.ordernum"
        type="textarea"
        placeholder="多个使用回车分割"
        autosize
        @blur="autoFormat('ordernum', { unique: true })"
      />
    </el-form-item>
    <!-- <el-form-item label="垚旌父订单号">
      <el-input
        v-model="queryParam.pordernum"
        type="textarea"
        placeholder="多个使用回车分割"
        autosize
      />
    </el-form-item> -->
    <el-form-item label="商品名称">
      <el-input v-model="queryParam.name" placeholder="输入商品名称" />
    </el-form-item>
    <el-form-item label="客户">
      <el-select
        v-model="queryParam.customerid"
        multiple
        filterable
        placeholder="选择客户"
      >
        <template v-for="item in customerData" :key="item.customerid">
          <el-option :label="item.name" :value="item.customerid" />
        </template>
      </el-select>
    </el-form-item>
    <el-form-item label="供应商">
      <el-select
        v-model="queryParam.supplierid"
        multiple
        filterable
        placeholder="选择供应商"
      >
        <template v-for="item in supplierData" :key="item.supplierid">
          <el-option :label="item.name" :value="item.supplierid" />
        </template>
      </el-select>
    </el-form-item>
    <el-form-item label="快递单号">
      <el-input v-model="queryParam.expressnum" placeholder="输入快递单号" />
    </el-form-item>
    <el-form-item label="收货人姓名">
      <el-input v-model="queryParam.receiver" type="textarea" placeholder="多个使用回车分割" autosize @blur="autoFormat('receiver', { unique: true })" />
    </el-form-item>
    <el-form-item label="收货人电话">
      <el-input
        v-model="queryParam.receiverphone"
        type="textarea"
        placeholder="多个使用回车分割"
        autosize
        @blur="autoFormat('receiverphone', { unique: true })"
      />
    </el-form-item>
    <el-form-item label="订单状态">
      <el-select v-model="queryParam.orderstatus" placeholder="选择订单状态">
        <el-option label="待发货" :value="1" />
        <el-option label="备货中" :value="2" />
        <el-option label="发货失败" :value="3" />
        <el-option label="已发货" :value="4" />
        <el-option label="发货完结" :value="5" />
        <el-option label="已取消" :value="6" />
      </el-select>
    </el-form-item>
    <el-form-item label="售后类型" prop="salestatus">
      <el-select v-model="queryParam.saletype" placeholder="选择售后类型">
        <el-option label="退货" :value="1" />
        <el-option label="换货" :value="2" />
        <el-option label="安比例赔付" :value="3" />
        <el-option label="仅退款未发货" :value="4" />
        <el-option label="其他" :value="5" />
      </el-select>
    </el-form-item>
    <el-form-item label="售后状态" prop="salestatus">
      <el-select v-model="queryParam.salestatus" placeholder="选择售后状态">
        <el-option label="未完成" :value="1" />
        <el-option label="已完成" :value="2" />
        <el-option label="已作废" :value="3" />
      </el-select>
    </el-form-item>
    <el-form-item label="供应商货款事宜" prop="supplieramount">
        <el-select v-model="queryParam.supplieramount" placeholder="请选择供应商货款事宜">
          <el-option label="未修改" :value="6" />
          <el-option label="已打款抵扣余款" :value="1" />
          <el-option label="未打款" :value="2" />
          <el-option label="月结已付抵扣余款" :value="3" />
          <el-option label="已退款" :value="4" />
          <el-option label="未退款" :value="5" />
        </el-select>
      </el-form-item>
    <el-form-item>
      <el-button type="danger" @click="getListOrderSale">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
        <el-button type="danger" @click="showExportOrderDialog" v-hasPermission="['sale:export']"
          >导出售后</el-button
        >
      </div>
    </el-col>
  </el-row>
  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-tabs class="tabs-log" v-model="activeTabName" @tab-click="doTabClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane name="uncomplete">
          <template #label>
            <span class="custom-tabs-label">
              <span>未完成</span>
              <el-link type="danger" style="margin-left:10px">{{countOrderSale[0]}}</el-link>
            </span>
          </template>
        </el-tab-pane>
        <el-tab-pane label="已完成" name="complete"></el-tab-pane>
        <el-tab-pane label="已作废" name="fail"></el-tab-pane>
      </el-tabs>
    </el-col>
  </el-row>
  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-table
        :data="tableData"
        v-loading="loadingData"
        @selection-change="doSelectionOrder"
        class="mainTable"
        row-key="orderid"
        height="600"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="售后操作时间" prop="orderSales.changed" width="155">
          <template #default="scope">
            <span
              v-text="
                util.formatDateUnix(
                  scope.row.orderSales.changed,
                  'yyyy-MM-dd hh:mm'
                )
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column label="平台订单号" prop="platformnum" width="200" />
        <el-table-column label="客户" prop="customer.name" width="100" />
        <el-table-column label="供应商" prop="supplier.name" width="100" />
        <el-table-column
          label="售后说明"
          prop="orderSales.salenote"
          width="120"
        />
        <el-table-column
          label="供应商货款事宜"
          prop="orderSales.supplieramount"
          width="140"
        >
          <template #default="scope">
            <span
              v-text="
                util.showSaleSupplieramount(scope.row.orderSales.supplieramount)
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column
          label="收货人姓名"
          prop="orderAddress.receiver"
          width="100"
        />
        <el-table-column
          label="收货人电话"
          prop="orderAddress.receiverphone"
          width="120"
        />
        <el-table-column label="商品名称" prop="name" width="200" />

        <el-table-column
          label="发货时间"
          prop="orderAddress.deliveryed"
          width="150"
        >
          <template #default="scope">
            <span
              v-text="
                util.formatDateUnix(
                  scope.row.orderAddress.deliveryed,
                  'yyyy-MM-dd hh:mm'
                )
              "
            ></span>
          </template>
        </el-table-column>        
        <el-table-column label="售后状态" prop="orderSales.salestatus">
          <template #default="scope">
           <template v-if="scope.row.orderSales.salestatus==1">
              <el-tag
              round
              type="warning"
              disable-transitions
              ><span
                v-text="util.showSaleStatus(scope.row.orderSales.salestatus)"
              ></span>
              </el-tag>
            </template>
            <template v-else-if="scope.row.orderSales.salestatus==2">
              <el-tag
              round
              type="success"
              disable-transitions
              ><span
                v-text="util.showSaleStatus(scope.row.orderSales.salestatus)"
              ></span>
              </el-tag>
            </template>
            <template v-else-if="scope.row.orderSales.salestatus==3">
              <el-tag
              round
              type="danger"
              disable-transitions
              ><span
                v-text="util.showSaleStatus(scope.row.orderSales.salestatus)"
              ></span>
              </el-tag>
            </template>

          </template>
        </el-table-column>
        <el-table-column
          label="售后完成时间"
          prop="orderSales.salecompleted"
          width="150"
        >
          <template #default="scope">
            <span
              v-text="
                util.formatDateUnix(
                  scope.row.orderSales.salecompleted,
                  'yyyy-MM-dd hh:mm'
                )
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="160">
          <template #default="scope">
            <el-link
              type="primary"
              size="small"
              @click="showSaleOptionDialog(scope.row)"
              v-hasPermission="['sale:edit']"
              >售后</el-link
            >
            <el-link
              type="primary"
              size="small"
              @click="showSaleOrderDialog(scope.row)"
              v-hasPermission="['sale:edit']"
              >修改</el-link
            >
            <el-link
              type="primary"
              size="small"
              @click="open('sale:view', scope.row)"
              v-hasPermission="['sale:view']"
              >详情</el-link
            >

            <el-popconfirm
              v-if="scope.row.orderSales.salestatus!=3"
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要作废此订单吗？"
              width="200px"
              @confirm="doSaleStatus(scope.$index, scope.row)"
            >
              <template #reference>
                <el-link
                  size="small"
                  type="danger"
                  v-hasPermission="['sale:cancel']"
                  >作废</el-link
                >
              </template>
            </el-popconfirm>

            <el-popconfirm
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要删除此订单售后吗？"
              width="200px"
              @confirm="doOrderSaleDelete(scope.$index, scope.row)"
            >
              <template #reference>
                <el-link
                 v-hasRole="['admin']"
                  size="small"
                  type="danger"
                  >删除</el-link
                >
              </template>
            </el-popconfirm>

          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="12">
      <div>
        <!-- <el-button type="danger" @click="showBatchOrderAccountDialog"
          >批量作废</el-button
        > -->
        <el-button type="danger" @click="showBatchSaleStatusDialog" v-hasPermission="['sale:batch']"
          >批量修改售后状态</el-button
        >
      </div>
    </el-col>
    <el-col :span="12">
      <div style="float: right">
        <el-pagination
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[20, 50, 100, 300, 600, 1000, 2000]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
          :current-page="queryParam.pageNo"
        />
      </div>
    </el-col>
  </el-row>
  <SaleOrder ref="RefSaleOrder" @click="getListOrderSale"/>
  <SaleOption ref="RefSaleOption" @click="getListOrderSale"/>
  <BatchSaleStatus ref="RefBatchSaleStatus" @click="getListOrderSale"/>
  <ExportOrder ref="RefExportOrder" />
</template>
        
<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElTable, ElMessage } from "element-plus";
import { listOrderSale, getOrderSaleCount, batchSaveSaleStatus, deleteOrderSale } from "@/api/order/sale";

import { listSupplierCache } from "@/api/supplier";
import { listCustomerCache } from "@/api/customer";
import util from "@/util/tool.js";

import storage from  "@/util/storage";


// import store from "@/store";

import SaleOption from "@/components/common/saleOption";
import SaleOrder from "@/components/common/saleOrder";
import BatchSaleStatus from "@/components/common/batchSaleStatus";
import ExportOrder from "@/components/common/exportOrder";

const loadingData = ref(true);

const router = useRouter();
let open = (routeName, row) => {
  storage.saveSessionObject("salePath",queryParam.value)

  router.push({
    name: routeName,
    params: { id: row.orderid },
    //query: { name: row.name },
  });
};

// let dateRange = ref([]);
let dateStartRange = ref();
let dateEndRange = ref();

const total = ref(0);
const pageSize = ref(20); //每页显示条数

const activeTabName = ref("all");
const doTabClick = (tab) => {
  let status = 0;
  if (tab.props.name === "all") {
    status = "";
  } else if (tab.props.name == "uncomplete") {
    status = 1;
  } else if (tab.props.name == "complete") {
    status = 2;
  } else if (tab.props.name == "fail") {
    status = 3;
  }
  queryParam.value.salestatus = status;
  getListOrderSale();
};

const multipleSelection = ref([]);
const doSelectionOrder = (val) => {
  multipleSelection.value = val;
};

//作废订单
const doSaleStatus = (index, obj,) => {
    let orders = [];
    
    orders.push({
      orderid: obj.orderid.toString(),
      salestatus: 3,
    });
  
    batchSaveSaleStatus(orders).then((res) => {
      if (res.data.code === 1) {
        getListOrderSale();
        getOrderSaleCounts();
      } else {
        ElMessage.error(res.data.msg);
      }
    })
     
  
};

//订单导出
let dialogExportOrderVisible = ref(false);
const RefExportOrder = ref();
const showExportOrderDialog = () => {
  if (tableData.value.length<=0) {
    ElMessage.error("无导出的数据!")
    return
  }
  RefExportOrder.value.changeVisible(!dialogExportOrderVisible.value);
  RefExportOrder.value.exportOrderMethod(queryParam.value);
  RefExportOrder.value.exportAction('sale');
};

//售后订单修改
let dialogSaleOrderVisible = ref(false);
const RefSaleOrder = ref();
const showSaleOrderDialog = (obj) => {
  RefSaleOrder.value.changeVisible(!dialogSaleOrderVisible.value);
  RefSaleOrder.value.saleMethod({
    realqty: obj.realqty,
    // costamount: obj.costamount,
    // saleamount: obj.saleamount,
    costamount: obj.orderSales.oldcostamount,
    saleamount: obj.orderSales.oldsaleamount,
    orderid: obj.orderid,
    // saleid: obj.orderSales.saleid,
    customerid: obj.customer.customerid,
  });
};

//订单售后
let dialogSaleOptionVisible = ref(false);
const RefSaleOption = ref();
const showSaleOptionDialog = (obj) => {
  RefSaleOption.value.changeVisible(!dialogSaleOptionVisible.value);
  RefSaleOption.value.saleMethod({
    applyed: obj.orderSales.applyed,
    saletype: obj.orderSales.saletype,
    reason: obj.orderSales.reason,
    salestatus: obj.orderSales.salestatus,
    supplieramount: obj.orderSales.supplieramount,
    salenote: obj.orderSales.salenote,
    orderid: obj.orderid,
    saleid: obj.orderSales.saleid,
  });
};

let dialogBatchSaleStatusVisible = ref(false);
const RefBatchSaleStatus = ref();
const showBatchSaleStatusDialog = () => {
  if (multipleSelection.value.length <= 0) {
    ElMessage.error("请先选择要处理的订单项");
    return false;
  }
  RefBatchSaleStatus.value.changeVisible(!dialogBatchSaleStatusVisible.value);

  let orderids = [];

  multipleSelection.value.forEach((order) => {
    orderids.push(order.orderid.toString());
  });

  RefBatchSaleStatus.value.saleStatusMethod({
    orderid: orderids,
  });
};


const countOrderSale = ref([])
const getOrderSaleCounts = () => {
  getOrderSaleCount({salestatus:1}).then((res)=>{
    countOrderSale.value = res.data.extend.counts
  })
}

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  platformnum: "",
  ordernum: "",
  pordernum: "",
  name: "",
  customerid: "",
  supplierid: "",
  expressnum: "",
  receiver: "",
  receiverphone: "",
  maolivstatus: "",
  orderstatus: "",
  salestatus: "",
  saletype: "",
  applyed: "",
  created: "",
  changed: "",
  supplieramount:"",
});

const autoFormat = (key, opt = {}) => {
  queryParam.value[key] = util.formatLineText(queryParam.value[key], opt);
};

const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    platformnum: "",
    ordernum: "",
    pordernum: "",
    name: "",
    customerid: "",
    supplierid: "",
    expressnum: "",
    receiver: "",
    receiverphone: "",
    maolivstatus: "",
    orderstatus: "",
    salestatus: "",
    saletype: "",
    applyed: "",
    created: "",
    changed: "",
    supplieramount:"",
  };
  defaultDate()
  getListOrderSale();
};

const defaultDate = () => {
    const today = new Date()
    const halfYearAgo = new Date(today)
    // 往前推6个月
    halfYearAgo.setMonth(halfYearAgo.getMonth() - 6)

    // 格式化日期 YYYY-MM-DD
    const formatDate = (date) => date.toISOString().slice(0, 10)

    // 赋值默认范围
    // dateRange.value = [
    //   formatDate(halfYearAgo),
    //   formatDate(today)
    // ]
    // queryParam.value.created = Date.parse(dateRange.value[0] + " 00:00:00");
    // queryParam.value.changed = Date.parse(dateRange.value[1] + " 23:59:59");

     dateStartRange.value =  formatDate(halfYearAgo)
     dateEndRange.value = formatDate(today)
     queryParam.value.created = Date.parse(dateStartRange.value + " 00:00:00");
     queryParam.value.changed = Date.parse(dateEndRange.value + " 23:59:59");
  }
// 2. 禁用逻辑：不能选未来，范围最6个月
const disabledDate = (time) => {
  console.log(time)
  // const now = Date.now()

  // 1. 禁用未来日期
  // if (time.getTime() > now) return true

  // 2. 已选开始日期 → 结束日期只能选 开始 ~ 开始+6个月
  // if (dateRange.value?.[0]) {
  //   const start = new Date(dateRange.value[0])
  //   const maxEnd = new Date(start)
  //   maxEnd.setMonth(maxEnd.getMonth() + 6) // 加6个月

  //   return time.getTime() < start || time.getTime() > maxEnd
  // }
  // if (dateStartRange.value) {
  //   const start = new Date(dateStartRange.value)
  //   const maxEnd = new Date(start)
  //   maxEnd.setMonth(maxEnd.getMonth() + 6) // 加6个月

  //   return time.getTime() < start || time.getTime() > maxEnd
  // }

  // return false
}
// 三、防止手动输入超过6个月
// const handleDateChange = () => {
//   if (!dateRange.value[0] || !dateRange.value[1]) return

//   const start = new Date(dateRange.value[0])
//   const end = new Date(dateRange.value[1])
//   const maxEnd = new Date(start)
//   maxEnd.setMonth(maxEnd.getMonth() + 6)

//   // 如果超出6个月，自动修正结束时间
//   if (end > maxEnd) {
//     dateRange.value[1] = maxEnd.toISOString().slice(0, 10)
//   }
//   queryParam.value.created = Date.parse(dateRange.value[0] + " 00:00:00");
//   queryParam.value.changed = Date.parse(dateRange.value[1] + " 23:59:59");
// }

const handleDateStartChange = () => {
  if (!dateStartRange.value) return
  if (dateEndRange.value) {
    if (dateStartRange.value > dateEndRange.value) {
      dateStartRange.value = ""
      queryParam.value.created = ""
      ElMessage.error('开始时间须小于结束时间');
      return false
    }
  }
  queryParam.value.created = Date.parse(dateStartRange.value + " 00:00:00");
}

const handleDateEndChange = () => {
  if (!dateEndRange.value) return

  if (dateStartRange.value > dateEndRange.value) {
    dateStartRange.value = ""
    queryParam.value.created = ""
    ElMessage.error('开始时间须小于结束时间');
    return false
  }
  queryParam.value.changed = Date.parse(dateEndRange.value + " 23:59:59");
}

const tableData = ref([]);

//客户列表API
const customerData = ref([]);
const customerReset = (customers) => {
  let dataTmp = [];
  customers.forEach((customer) => {
    customer.customerid = customer.customerid.toString();
    dataTmp.push(customer);
  });
  return dataTmp;
};
const getListCustomer = () => {
  listCustomerCache({ pageNo: 1, pageSize: 1000, status: 1 }).then((res) => {
    customerData.value = customerReset(res.data.extend.pages.list);
  });
};

//供应商列表API
const supplierData = ref([]);
const supplierReset = (suppliers) => {
  let dataTmp = [];
  suppliers.forEach((supplier) => {
    supplier.supplierid = supplier.supplierid.toString();
    dataTmp.push(supplier);
  });
  return dataTmp;
};
const getListSupplier = () => {
  listSupplierCache({ pageNo: 1, pageSize: 5000, status: 1 }).then((res) => {
    supplierData.value = supplierReset(res.data.extend.pages.list);
  });
};

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListOrderSale();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListOrderSale();
};

//订单表API
const getListOrderSale = () => {
  storage.remove('salePath')

  if (!dateStartRange.value || !dateEndRange.value) {
    defaultDate()
  }

  let query = JSON.parse(JSON.stringify(queryParam.value)); 
  query.supplierids = query.supplierid?query.supplierid.join(','):''
  query.customerids = query.customerid?query.customerid.join(','):''
  delete query.customerid
  delete query.supplierid
  console.log(query)
  
  listOrderSale(query).then((res) => {
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    tableData.value = res.data.extend.pages.list;
    loadingData.value = false
  });
};

const doOrderSaleDelete = (index, obj) => {
  let query = JSON.parse(JSON.stringify(obj.orderSales)); 
  query.orderid = obj.orderid
  deleteOrderSale(query).then((res) => {
    if (res.data.code === 1) {
      getListOrderSale();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};

//onMounted方法
onMounted(() => {
  let query = storage.getSessionObject("salePath")
  if (query) {
    queryParam.value = query
  }

  defaultDate()

  getListCustomer();
  getListSupplier();
  getListOrderSale();
  getOrderSaleCounts();
});
</script>
<style scoped>
.waitTab {
  margin-top: 15px;
}
.waitTab .item {
  margin-right: 40px;
}
</style>